import React, { Component } from "react";
import axios from "axios";
import moment from "moment";
import { connect } from "react-redux";
import { Form, DatePicker, Select, Input, message } from "antd";
import { ModalItem, SelectEmpleadosItem, fechaDiaParaPayload } from "../../../Components/Items";

const { Option } = Select;

// Asigna una o varias agrupaciones de una etapa con control por persona a un empleado.
// Lo abren el tablero "Por persona" (al arrastrar desde "Por asignar") y el Kanban por etapa
// (al mover una pieza a una etapa controlada).
//
// props: visible, agrupacionIds, descripcion (texto de las piezas), etapa ({_id, nombre,
// personal?}), empleadoIdInicial, onCerrar(asignado)
class ModalAsignar extends Component {
  formRef = React.createRef();
  state = { loading: false, personal: null };

  componentDidUpdate(prevProps) {
    if (prevProps.visible && !this.props.visible) {
      this.setState({ personal: null });
    }
    if (!prevProps.visible && this.props.visible) {
      if (Array.isArray(this.props.etapa?.personal)) {
        this.setState({ personal: this.props.etapa.personal });
      } else {
        this.consultarPersonal();
      }
    }
  }

  consultarPersonal = () => {
    this.setState({ loading: true, personal: null });
    axios
      .post(
        "asignacionesAgrupacion/selectPersonalEtapa",
        { empresaId: this.props.empresaId, etapaId: this.props.etapa?._id },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        this.setState({ loading: false, personal: res.data.success === 2 ? res.data.etapa.personal : [] });
      })
      .catch(() => {
        this.setState({ loading: false, personal: [] });
      });
  };

  asignar = async () => {
    let values;
    try {
      values = await this.formRef.current.validateFields();
    } catch (e) {
      return;
    }

    this.setState({ loading: true });
    try {
      const res = await axios.post(
        "asignacionesAgrupacion/asignarAgrupaciones",
        {
          empresaId: this.props.empresaId,
          agrupacionIds: this.props.agrupacionIds,
          etapaId: this.props.etapa?._id,
          empleadoId: values.empleadoId,
          fechaInicio: fechaDiaParaPayload(values.fechaInicio),
          notas: values.notas || "",
        },
        { headers: this.props.headersToken }
      );
      this.setState({ loading: false });

      if (res.data.success !== 2) {
        message.warning(res.data.message || "No se pudo asignar");
        return;
      }
      const { asignadas = 0, omitidas = [] } = res.data;
      if (omitidas.length === 0) {
        message.success(asignadas === 1 ? "Pieza asignada" : `${asignadas} piezas asignadas`);
      } else {
        message.warning(
          `${asignadas} asignada(s). No se asignaron: ` +
            omitidas.map((o) => `${o.numero} (${o.motivo})`).join(", ")
        );
      }
      this.props.onCerrar(asignadas > 0);
    } catch (err) {
      this.setState({ loading: false });
      console.error(err);
      message.error("Error al asignar");
    }
  };

  renderSelectorEmpleado() {
    const { personal } = this.state;
    if (personal && personal.length > 0) {
      return (
        <Select placeholder="Elige a la persona" showSearch optionFilterProp="children">
          {personal.map((p) => (
            <Option key={String(p._id)} value={String(p._id)}>
              {p.nombre}
            </Option>
          ))}
        </Select>
      );
    }
    // Etapa sin personal configurado: cualquier empleado activo.
    return (
      <SelectEmpleadosItem
        empresaId={this.props.empresaId}
        headersToken={this.props.headersToken}
        width="100%"
        placeholder="Busca al empleado"
      />
    );
  }

  render() {
    const { visible, etapa, descripcion, empleadoIdInicial } = this.props;
    return (
      <ModalItem
        title={`Asignar en ${etapa?.nombre || "la etapa"}`}
        visible={visible}
        spinning={this.state.loading}
        onCancel={() => this.props.onCerrar(false)}
        onOk={this.asignar}
        okText="Asignar"
        cancelText="Ahora no"
        footer
        destroyOnClose
        width={520}
        paddingTop
      >
        {descripcion && <div style={{ marginBottom: 12, color: "#555" }}>{descripcion}</div>}
        {this.state.personal !== null && (
          <Form
            ref={this.formRef}
            layout="vertical"
            initialValues={{
              empleadoId: empleadoIdInicial ? String(empleadoIdInicial) : undefined,
              fechaInicio: moment(),
              notas: "",
            }}
          >
            <Form.Item
              name="empleadoId"
              label="¿Quién la trabaja?"
              rules={[{ required: true, message: "Elige a la persona" }]}
            >
              {this.renderSelectorEmpleado()}
            </Form.Item>
            <Form.Item
              name="fechaInicio"
              label="Fecha de inicio"
              rules={[{ required: true, message: "Captura la fecha de inicio" }]}
            >
              <DatePicker
                format="DD/MM/YYYY"
                style={{ width: "100%" }}
                allowClear={false}
                disabledDate={(fecha) => fecha && fecha > moment().endOf("day")}
              />
            </Form.Item>
            <Form.Item name="notas" label="Notas">
              <Input.TextArea rows={2} maxLength={500} placeholder="Opcional" />
            </Form.Item>
          </Form>
        )}
      </ModalItem>
    );
  }
}

const mapStateToProps = (state) => ({
  headersToken: state.user.headersToken,
  empresaId: state.empresa.id,
});

export default connect(mapStateToProps)(ModalAsignar);
